import { toast } from "sonner";
import { ClientError } from "@/client/api";
import { GenAiAPI } from "@/client/context";
import getRouterBasename from "@/utils/router";

// const server =
//   (import.meta.env.VITE_API_BASE_URL ?? "http://localhost:3000") +
//   getRouterBasename();
const runtimeConfig = (window as any).__RUNTIME_CONFIG__;
const server =
  (runtimeConfig?.API_BASE_URL ?? "http://10.100.14.72:3001") +
  getRouterBasename();

const url = server;
const serverUrl = new URL(url);

const httpEndpoint = serverUrl.toString();

const inProgressErrors = new Set<string>();

const on401 = () => {
  if (window.location.pathname !== getRouterBasename() + "/login") {
    // The credentials aren't correct, remove the token and redirect to login
    // window.location.href = getRouterBasename() + "/login";
  }
};

const showToastOnce = (message: string) => {
  if (inProgressErrors.has(message)) return;

  inProgressErrors.add(message);
  toast.error(message);

  // Remove this error from the set after 0.1 seconds just to prevent spamming from duplicate fetches
  setTimeout(() => {
    inProgressErrors.delete(message);
  }, 100);
};

const onError = (error: unknown) => {
  if (error instanceof ClientError) {
    const errorMessage = error?.message?.toLowerCase() ?? "";

    if (errorMessage.includes("expired token")) {
      setTimeout(() => {
        window.location.href = getRouterBasename() + "/login";
      }, 1500);
      return;
    }

    showToastOnce(error.toString());
    return;
  }

  showToastOnce("Network error. Please try again.");
};

export const apiClient = new GenAiAPI(httpEndpoint, "webapp", on401, onError);
